import http from '../http'
import { IBillingPlanDto, ICreditPackDto } from './dtos'
import { mapCreditPacksFromDto, mapPlansFromDto } from './helpers'
import { ICheckoutParams } from './models'

const billingsAPI = http.createClient(`${process.env.NEXT_PUBLIC_API_URL}/billings`)

export const getPlans = async () => {
	const { data } = await billingsAPI.get<IBillingPlanDto[]>('/plans')
	return data.map(mapPlansFromDto)
}

export const changePlan = async (planName: IBillingPlanDto['name']) => {
	const { data } = await billingsAPI.post('/plans', {
		planName,
	})
	return data
}

export const getCreditPacks = async () => {
	const { data } = await billingsAPI.get<ICreditPackDto[]>('/credit-packages')
	return data.map(mapCreditPacksFromDto)
}

export const getStripeDashboardLink = async ({ returnUrl }: { returnUrl: string }) => {
	const { data } = await billingsAPI.post<string>('/dashboard', { returnUrl })
	return data
}

export const generateCheckoutLink = async (params: ICheckoutParams) => {
	const { data } = await billingsAPI.post<string>('/checkout', params)
	return data
}
